const SaleSegregation = () => import(/* webpackChunkName: "saleSegregation" */ './SaleSegregation.vue')
const FormSeller = () => import(/* webpackChunkName: "formSeller" */ './FormSeller.vue')
const FormSection = () => import(/* webpackChunkName: "formSection" */ './FormSection.vue')

const index = {
  path: 'sale/segregation',
  name: 'Sale Segregation',
  component: SaleSegregation,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const createSeller = {
  path: 'sale/segregation/seller',
  name: 'Seller',
  component: FormSeller,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const createSection = {
  path: 'sale/segregation/section',
  name: 'Section',
  component: FormSection,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const editSeller = {
  path: 'sale/origin/seller/:cnpj/:cpf',
  name: 'Edit Seller',
  component: FormSeller,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const editSection = {
  path: 'sale/origin/section/:cnpj/:idSecao',
  name: 'Edit Section',
  component: FormSection,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index,
  createSeller,
  createSection,
  editSeller,
  editSection
}
